import {ChangeDetectorRef, Component, Input, OnChanges, OnInit} from '@angular/core';
import {ClientConfiguration} from '@twpub/core/utils';
import {ClientConfigurationService, SharedStateService} from '@twpub/core/services';
import {NGXLogger} from 'ngx-logger';
import {SecurityConfigService} from '@twpub/shared/services/security-config.service';
import {filter, take} from 'rxjs';

import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatIcon} from '@angular/material/icon';
import {MatDivider} from '@angular/material/list';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'pub-configuration-selector',
  templateUrl: './configuration-selector.component.html',
  styleUrls: ['./configuration-selector.component.scss'],
  standalone: true,
  imports: [MatMenuTrigger, MatMenu, MatMenuItem, MatIcon, MatDivider, MatTooltip]
})
export class ConfigurationSelectorComponent implements OnInit, OnChanges {
  @Input() visible = false;

  configurations: ClientConfiguration[] = [];
  selectedFlags: boolean[] = [];
  private loaded = false;

  tooltipLabel = $localize`:@@header.pageLayouts:Page Layouts`;
  defaultLayoutLabel = $localize`:@@header.defaultLayout:Default layout`;

  constructor(private logger: NGXLogger, private configService: ClientConfigurationService,
              private sharedStateService: SharedStateService, private securityService: SecurityConfigService,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    // Wait for auth to be ready, then load configurations
    this.securityService.authInitialized$.pipe(
      filter(initialized => initialized),
      take(1)
    ).subscribe(() => this.loadConfigurations());
  }

  ngOnChanges(): void {
    if (this.visible && !this.loaded) {
      this.loadConfigurations();
    }
  }

  private loadConfigurations(): void {
    if (this.loaded) return;
    if (!this.securityService.isAdmin()) return;
    const currentId = this.sharedStateService.getConfigId() || 0;
    this.configService.getConfigurations().subscribe({
      next: (configs) => {
        this.loaded = true;
        this.configurations = configs;
        const allConfigs: Partial<ClientConfiguration>[] = [{id: 0}, ...configs];
        this.selectedFlags = allConfigs.map((config) => +config.id! === +currentId);
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.logger.error('Failed to load configurations:', err);
        this.cdr.detectChanges();
      }
    });
  }

  onClick(id: number) {
    this.sharedStateService.selectConfiguration(id);
  }
}
